import React from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import PublicLayout from '../components/PublicLayout';
import PasswordResetForm from '../forms/PasswordResetForm';

const useStyles = makeStyles(() => ({
  container: {
    paddingBottom: '3rem',
    paddingTop: '3rem',
  },
}));

const PasswordReset = () => {
  const classes = useStyles();

  return (
    <PublicLayout>
      <Container maxWidth='md' className={classes.container}>
        <Typography variant='h1' gutterBottom>Réinitialisation du mot de passe</Typography>
        {/* <Typography paragraph variant='subtitle1' color='textSecondary'>
          Vous allez recevoir un e-mail avec le lien de modification du mot de passe.
        </Typography> */}
        <Container maxWidth='sm' className={classes.container}>
          <PasswordResetForm />
        </Container>
        <Typography align='center' variant='body2' color='textSecondary'>
          {`Vous rencontrez un problème ? Contactez-nous à l'adresse `}
          <a href="mailto:rallye.hiver.2021@gmail.com">rallye.hiver.2021@gmail.com</a>
        </Typography>
      </Container>
    </PublicLayout>
  )
}

export default PasswordReset;
